
import DialogTemplate from '@/_components/dialog/template/template.vue'
import CompanyInfoMixin from '@/_mixins/companyInfo.mixin.ts'
import {
    PROJECT_CARD_HISTORY_EVENTS_QUERY,
    PROJECT_GROUP_COMPANY_HISTORY_EVENTS_QUERY,
} from './gql/queries'
import { accessClient } from '@/apolloClient'
import LogTemplate from '@/views/Log/components/template/template.vue'

export default {
    name: 'AccessControlUserRuleDialog',
    mixins: [CompanyInfoMixin],
    components: { DialogTemplate, LogTemplate },
    props: {
        props: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isFetchingEvents: false,
            events: null,
        }
    },
    computed: {
        card() {
            return this.props.card
        },
        groups() {
            return Object.groupBy(this.props.groups, (group) => group.id)
        },
        value() {
            const items = new Map()
            const availableRules = new Set()

            for (const groupCard of this.props.groupCards) {
                this.props.rulesByGroup[groupCard.groupId]?.forEach((groupRule) => {
                    availableRules.add(groupRule.ruleId)
                    if (!items.get(groupRule.readerId)) {
                        items.set(groupRule.readerId, { [groupRule.ruleId]: true })
                    } else {
                        items.get(groupRule.readerId)[groupRule.ruleId] = true
                    }
                })
            }

            for (const groupCompany of this.props.groupCompanies) {
                this.props.rulesByGroup[groupCompany.groupId]?.forEach((groupRule) => {
                    availableRules.add(groupRule.ruleId)
                    if (!items.get(groupRule.readerId)) {
                        items.set(groupRule.readerId, { [groupRule.ruleId]: true })
                    } else {
                        items.get(groupRule.readerId)[groupRule.ruleId] = true
                    }
                })
            }

            return {
                rules: this.props.rules.filter((rule) => availableRules.has(rule.id)),
                rulesByReader: items,
            }
        },
    },
    methods: {
        async getHistoryEvents() {
            if (this.isFetchingEvents || this.events) {
                return
            }

            let query, variables

            if (this.card.id) {
                query = PROJECT_CARD_HISTORY_EVENTS_QUERY
                variables = { projectCardId: this.card.id }
            } else if (this.card.bklrInternalCompanyId) {
                query = PROJECT_GROUP_COMPANY_HISTORY_EVENTS_QUERY
                variables = {
                    projectId: this.currentProjectId,
                    bklrInternalCompanyId: this.card.bklrInternalCompanyId,
                }
            } else {
                return
            }

            try {
                this.isFetchingEvents = true
                const eventResult = await accessClient.query({
                    query,
                    variables,
                    fetchPolicy: 'network-only',
                })
                const operationName = query.definitions[0].name.value
                this.events = eventResult.data[operationName] || []
            } finally {
                this.isFetchingEvents = false
            }
        },
    },
}
